var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ac space-between top"},[_c('span',{staticClass:"title1"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.desc)?_c('span',{staticClass:"desc"},[_vm._v(" "+_vm._s(_vm.desc)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }